/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trackNumber: NonNullable<unknown> }} Track_Label_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Track {trackNumber}" |
*
* @param {Track_Label_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_label_aria_label = /** @type {((inputs: Track_Label_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Label_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Piste ${i?.trackNumber}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Track ${i?.trackNumber}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Traccia ${i?.trackNumber}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Трек ${i?.trackNumber}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Pista ${i?.trackNumber}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`追踪${i?.trackNumber}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラック ${i?.trackNumber}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक ${i?.trackNumber}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Faixa ${i?.trackNumber}`)
	return /** @type {LocalizedString} */ (`Track ${i?.trackNumber}`)
});